export default __webpack_public_path__ + "static/media/mousai_mobile.f7627688.png";